$(function () {

    google.maps.event.addDomListener(window, 'load', init);
    var map;

    function init() {
        var mapOptions = {
            center: new google.maps.LatLng(37.793575, 140.408936),
            zoom: 15,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.DEFAULT,
            },
            disableDoubleClickZoom: true,
            mapTypeControl: false,
            scaleControl: true,
            scrollwheel: false,
            panControl: true,
            streetViewControl: true,
            draggable: false,
            overviewMapControl: true,
            overviewMapControlOptions: {
                opened: false,
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{"visibility": "on"}, {"color": "#a9d7d7"}]
            }, {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [{"color": "#e1e9cf"}]
            }, {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [{"color": "#96b74b"}]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [{"color": "#7ba124"}]
            }, {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers": [{"color": "#ffffff"}]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [{"visibility": "simplified"}, {"color": "#8dab68"}]
            }, {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [{"visibility": "simplified"}]
            }, {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [{"color": "#6e7b51"}]
            }, {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [{"color": "#ffffff"}]
            }, {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [{"visibility": "off"}]
            }, {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [{"color": "#cbdda3"}]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [{"color": "#cbdda3"}]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{"color": "#f6eb73"}]
            }, {"featureType": "transit", "stylers": [{"visibility": "off"}]}, {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [{"visibility": "on"}, {"color": "#87ae79"}]
            }, {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [{"color": "#7f2200"}, {"visibility": "off"}]
            }, {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [{"color": "#ffffff"}, {"visibility": "on"}, {"weight": 4.1}]
            }, {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{"color": "#bbb39f"}]
            }, {
                "featureType": "administrative.neighborhood",
                "elementType": "labels",
                "stylers": [{"visibility": "off"}]
            }]
        };
        var mapElement = document.getElementById('katofarm');
        var map = new google.maps.Map(mapElement, mapOptions);
        //images/assets/mappin.png
        var image = {
            url : '../images/assets/mappin@2x.png',
            scaledSize : new google.maps.Size(60, 82)
        };
        var marker = new google.maps.Marker({
            icon: image,
            position: mapOptions.center,
            map: map
        });
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/js/module/map.js
 ** module id = 5
 ** module chunks = 3
 **/